<template>
  <div class="gardenInfoAdministration">
    <el-card>
      <div class="flexBox">
        <el-tabs @tab-click="handleClick" v-model="activeTabName">
          <el-tab-pane label="项目小区信息" name="0"></el-tab-pane>
          <el-tab-pane label="小区构成明细" name="1"></el-tab-pane>
          <el-tab-pane label="小区大门信息" name="2"></el-tab-pane>
          <el-tab-pane label="小区配电信息" name="3"></el-tab-pane>
          <el-tab-pane label="小区消防信息" name="4"></el-tab-pane>
          <el-tab-pane label="小区周边配套" name="5"></el-tab-pane>
          <el-tab-pane label="公共收益信息" name="6"></el-tab-pane>
        </el-tabs>
        <!-- <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
        </div> -->
      </div>
      <garden-projectInfo v-if="tabIndex==0"></garden-projectInfo>
      <garden-compositionDetail v-if="tabIndex==1"></garden-compositionDetail>
      <garden-doorsList v-if="tabIndex==2"></garden-doorsList>
      <garden-distributionList v-if="tabIndex==3"></garden-distributionList>
      <garden-fireControlList v-if="tabIndex==4"></garden-fireControlList>
      <garden-matchingList v-if="tabIndex==5"></garden-matchingList>
      <garden-profitInfo v-if="tabIndex==6"></garden-profitInfo>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenInfoAdministration
   *@Description:物业小区信息管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import gardenProjectInfo from './components/gardenProjectInfo.vue'
  import gardenCompositionDetail from './components/gardenCompositionDetail.vue'
  import gardenDoorsList from './components/gardenDoorsList.vue'
  import gardenDistributionList from './components/gardenDistributionList.vue'
  import gardenFireControlList from './components/gardenFireControlList.vue'
  import gardenMatchingList from './components/gardenMatchingList.vue'
  import gardenProfitInfo from './components/gardenProfitInfo.vue'
  
  export default {
    data() {
      return {
        // 企业基本信息
        tabIndex: 0, // tab栏下标
        activeTabName: '0', // tab默认值
      }
    },
    components: {
      'garden-projectInfo': gardenProjectInfo,
      'garden-compositionDetail': gardenCompositionDetail,
      'garden-doorsList': gardenDoorsList,
      'garden-distributionList': gardenDistributionList,
      'garden-fireControlList': gardenFireControlList,
      'garden-matchingList': gardenMatchingList,
      'garden-profitInfo': gardenProfitInfo
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {

    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 切换tab
      handleClick(tab) {
        this.tabIndex = tab.index
      },

    },
  }
</script>

<style lang="scss">
  .gardenInfoAdministration {
    .flexBox {
      display: flex;

      .el-tabs {
        background-color: #fff !important;
        flex: 1;
        overflow: hidden;
      }

      .el-tabs__nav-wrap {
        // width: 99%!important;
        position: static !important;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:nth-last-child(2) {
        padding-left: 20px !important;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:last-child {
        padding-right: 20px !important;
      }
    }
  }
</style>